import { render, staticRenderFns } from "./drawlot-data.vue?vue&type=template&id=20d3647c&scoped=true&"
import script from "./drawlot-data.vue?vue&type=script&lang=js&"
export * from "./drawlot-data.vue?vue&type=script&lang=js&"
import style0 from "./drawlot-data.vue?vue&type=style&index=0&id=20d3647c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3647c",
  null
  
)

export default component.exports